import React from "react";
import { motion } from "framer-motion";
import { Camera, FileText, MapPin, Hammer } from "lucide-react";

const STEPS = [
  {
    n: "01",
    icon: Camera,
    title: "Send photos or enquiry",
    desc: "Drop your photos, postcode and a quick message. Takes under 60 seconds.",
  },
  {
    n: "02",
    icon: FileText,
    title: "Get a quick quote",
    desc: "We review, call you back and return a clear, fixed-price quote — typically same day.",
  },
  {
    n: "03",
    icon: MapPin,
    title: "Site visit if needed",
    desc: "For bigger projects we'll arrange a free site visit at a time that suits you.",
  },
  {
    n: "04",
    icon: Hammer,
    title: "Work starts",
    desc: "Crews arrive on the agreed date, protect the space and deliver on programme.",
  },
];

export default function Process() {
  return (
    <section
      id="process"
      data-testid="process-section"
      className="bg-white text-[#2B2420] py-20 md:py-28"
    >
      <div className="px-6 md:px-10 lg:px-16">
        <div className="max-w-3xl mb-12 md:mb-16">
          <div className="flex items-center gap-3 text-[11px] uppercase tracking-[0.3em] text-[#B8732C] mb-5">
            <span className="brand-gold-divider" /> How it works
          </div>
          <h2
            className="font-black tracking-tighter leading-[0.95] text-4xl md:text-5xl lg:text-6xl"
            style={{ fontFamily: "Cabinet Grotesk" }}
          >
            Four simple steps.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 border-t border-l border-[#E5DDD0]">
          {STEPS.map((s, i) => {
            const Icon = s.icon;
            return (
              <motion.div
                key={s.n}
                data-testid={`process-step-${i + 1}`}
                initial={{ opacity: 0, y: 18 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 0.5, delay: i * 0.08 }}
                className="border-r border-b border-[#E5DDD0] p-7 md:p-9 bg-white hover:bg-[#F5EFE5] transition-colors"
              >
                <div className="flex items-center justify-between mb-8">
                  <span
                    className="font-black text-3xl md:text-4xl text-[#B8732C] leading-none"
                    style={{ fontFamily: "Cabinet Grotesk" }}
                  >
                    {s.n}
                  </span>
                  <Icon className="w-6 h-6 text-[#C9A24C]" strokeWidth={1.5} />
                </div>
                <h3
                  className="font-black tracking-tight text-xl md:text-2xl leading-[1.15]"
                  style={{ fontFamily: "Cabinet Grotesk" }}
                >
                  {s.title}
                </h3>
                <p className="mt-3 text-[#8A7F74] text-sm leading-relaxed">{s.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
